import React from 'react';
import '../../filterablePeripheralList/peripheralList/peripheralRow/peripheralRow.css'

class GPIORow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: this.props.userPinNames[this.props.pinLocation]
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        const invalidChars = /[^a-zA-Z0-9_]/g;
        let cur_name = (evt.target.value).replace(invalidChars, '');
        // Prevent starting with number
        if (this.state.name === "" && !isNaN(cur_name)) {
            return;
        }
        this.setState({name: cur_name});
        this.props.userPinNames[this.props.pinLocation] = cur_name;
    }

    render() {

        let pinNumStyle = {
            display: "block",
            fontSize: "0.8em",
            width: "3em",
        }

        let inputNameStyle = {
            marginLeft: "1em",
            fontSize: "0.8em",
        }

        return (
            <tr>
                <td>
                    <div className="row-peripheral">
                        <span style={pinNumStyle}>
                            P{this.props.pinLocation}
                        </span>

                        <input style={inputNameStyle}
                            pattern="[a-zA-Z0-9]"
                            placeholder={"PIN_GPIO_" + this.props.pinLocation}
                            value={this.state.name}
                            onChange={this.handleChange}/>
                    </div>
                </td>
            </tr>
        );
    }
}

export default GPIORow;
